import {
  GradientColorStop,
  interpolateGradientColor,
} from '@app/helpers/interpolate-gradient-color';
import { Palette } from '@mui/material/styles';

/**
 * Default breakpoints for the progress KPI ramp (error → warning → success).
 * Distinct from stream-quality rates (0.8 / 0.9 / 1), which are tuned for near-healthy streams.
 */
export const KPI_PROGRESS_GRADIENT_RATES = {
  error: 0,
  warning: 0.5,
  success: 1,
} as const;

/**
 * Builds theme-aware stops for progress KPI bars from MUI palette semantic colors.
 */
export function buildKpiProgressGradientStops(palette: Palette): GradientColorStop[] {
  return [
    { rate: KPI_PROGRESS_GRADIENT_RATES.error, color: palette.error.main },
    { rate: KPI_PROGRESS_GRADIENT_RATES.warning, color: palette.warning.main },
    { rate: KPI_PROGRESS_GRADIENT_RATES.success, color: palette.success.main },
  ];
}

/**
 * Resolves the continuous KPI progress color for a rate in [0, 1]
 * (0 = error, 0.5 = warning, 1 = success).
 */
export function resolveKpiProgressGradientColor(rate0to1: number, palette: Palette): string {
  return interpolateGradientColor(rate0to1, buildKpiProgressGradientStops(palette));
}
